function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurityOff = function SvgSecurityOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.2 37"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1 37a1.44 1.44 0 0 1-.67-.16C13.84 36.55 0 29.5 0 18.5V4.9a1.51 1.51 0 0 1 1.14-1.46L14.74 0a1.75 1.75 0 0 1 .72 0l13.6 3.4a1.51 1.51 0 0 1 1.14 1.5v13.6c0 11-13.84 18-14.43 18.34a1.44 1.44 0 0 1-.67.16ZM3 6.07V18.5c0 7.91 9.47 13.81 12.1 15.29 2.63-1.48 12.1-7.38 12.1-15.29V6.07l-12.1-3Z",
    style: {
      fill: "#fff"
    },
    "data-name": "Layer 1"
  })));
};
export default SvgSecurityOff;